// Options courantes
import {CritèreRecherche} from "./CritèreRecherche.js";
import {Cibles} from "./Cibles.js";
import {Comparateurs} from "./ComparateurCritère.js";
import {
    classeDeMotValeurs,
    listeMEQValeurs,
    meqComposition,
    meqDérivation,
    meqFormationDuFéminin,
    meqFormationDuPluriel,
    meqThème,
    meqVariationEnGenre,
    meqVariationEnNombre
} from "./constantes.js";
import {OptionRecherche} from "./OptionRecherche.js";

class SuggestionCatégorie {
    constructor(code, nom, affiche) {
        this.code = code;
        this.nom = nom;
        this.affiche = affiche;
    }
}

export const SuggestionCatégories = {
    "MEQ": new SuggestionCatégorie("MEQ", "Niveau scolaire", true),
    "MEQ_CLASSES": new SuggestionCatégorie("MEQ_CLASSES", "Classes de mots", true),
    "MEQ_FORMATION_DES_MOTS": new SuggestionCatégorie("MEQ_FORMATION_DES_MOTS", "Formation des mots", true),
    "MEQ_FORMATION_DU_FÉMININ": new SuggestionCatégorie("MEQ_FORMATION_DU_FÉMININ", "Formation du féminin", true),
    "MEQ_FORMATION_DU_PLURIEL": new SuggestionCatégorie("MEQ_FORMATION_DU_PLURIEL", "Formation du pluriel", true),
    "MEQ_VARIATION_EN_GENRE": new SuggestionCatégorie("MEQ_VARIATION_EN_GENRE", "Variation en genre", true),
    "MEQ_VARIATION_EN_NOMBRE": new SuggestionCatégorie("MEQ_VARIATION_EN_NOMBRE", "Variation en nombre", true),
    "MEQ_THÈME": new SuggestionCatégorie("MEQ_THÈME", "Thèmes", true),
    "AUTRES": new SuggestionCatégorie("AUTRES", "Autres suggestions de recherche de mots", false),

};

export const Suggestions = {
    [SuggestionCatégories.MEQ.code]: getListeSuggestions(),
    [SuggestionCatégories.MEQ_CLASSES.code]: getClassesDeMots(),
    [SuggestionCatégories.MEQ_FORMATION_DES_MOTS.code]: getFormationDesMotSuggestions(),
    [SuggestionCatégories.MEQ_FORMATION_DU_FÉMININ.code]: getValeursSimplesSuggestions(Cibles.MEQ_FORMATION_DU_FÉMININ, meqFormationDuFéminin),
    [SuggestionCatégories.MEQ_FORMATION_DU_PLURIEL.code]: getValeursSimplesSuggestions(Cibles.MEQ_FORMATION_DU_PLURIEL, meqFormationDuPluriel),
    [SuggestionCatégories.MEQ_VARIATION_EN_GENRE.code]: getValeursSimplesSuggestions(Cibles.MEQ_VARIATION_EN_GENRE, meqVariationEnGenre),
    [SuggestionCatégories.MEQ_VARIATION_EN_NOMBRE.code]: getValeursSimplesSuggestions(Cibles.MEQ_VARIATION_EN_NOMBRE, meqVariationEnNombre),
    [SuggestionCatégories.MEQ_THÈME.code]: getValeursSimplesSuggestions(Cibles.MEQ_THÈME, meqThème),

    [SuggestionCatégories.AUTRES.code]: [
        {
            nom: "Les verbes en -eler",
            critères: [
                new CritèreRecherche(Cibles.CLASSE_DE_MOT.code, Comparateurs.ÉGALE.code, [classeDeMotValeurs.get("verbe").join()]),
                new CritèreRecherche(Cibles.LEMME.code, Comparateurs.SE_TERMINE_PAR.code, ["eler"])
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        },
        {
            nom: `Les mots qui se terminent par "ment" qui ne sont pas des adverbes`,
            critères: [
                new CritèreRecherche(Cibles.CLASSE_DE_MOT.code, Comparateurs.EST_DIFFÉRENT.code, [classeDeMotValeurs.get("adverbe").join()]),
                new CritèreRecherche(Cibles.LEMME.code, Comparateurs.SE_TERMINE_PAR.code, ["ment"])
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        },
        {
            nom: `Les noms masculins dont le lemme se termine par "al" et le pluriel ne se termine pas par "aux"`,
            critères: [
                new CritèreRecherche(Cibles.CLASSE_DE_MOT.code, Comparateurs.ÉGALE.code, [classeDeMotValeurs.get("nom").join()]),
                new CritèreRecherche(Cibles.GENRE.code, Comparateurs.ÉGALE.code, ["m"]),
                new CritèreRecherche(Cibles.NOMBRE.code, Comparateurs.ÉGALE.code, ["p"]),
                new CritèreRecherche(Cibles.LEMME.code, Comparateurs.SE_TERMINE_PAR.code, ["al"]),
                new CritèreRecherche(Cibles.GRAPHIE.code, Comparateurs.NE_SE_TERMINE_PAS_PAR.code, ["aux"])
            ],
            options: OptionRecherche.FiltreToutesLesFormesSaufVerbesConjuguésOptions
        },
        {
            nom: `Les noms dont le lemme se termine par "ou" et le pluriel ne se termine pas par "s"`,
            critères: [
                new CritèreRecherche(Cibles.CLASSE_DE_MOT.code, Comparateurs.ÉGALE.code, [classeDeMotValeurs.get("nom").join()]),
                new CritèreRecherche(Cibles.NOMBRE.code, Comparateurs.ÉGALE.code, ["p"]),
                new CritèreRecherche(Cibles.LEMME.code, Comparateurs.SE_TERMINE_PAR.code, ["ou"]),
                new CritèreRecherche(Cibles.GRAPHIE.code, Comparateurs.NE_SE_TERMINE_PAS_PAR.code, ["s"])
            ],
            options: OptionRecherche.FiltreToutesLesFormesSaufVerbesConjuguésOptions
        },
    ],


}

function getThèmesSuggestions() {
    return [...meqThème.entries()].map(([c, v]) => {
        return {
            nom: c.charAt(0).toUpperCase() + c.slice(1),
            critères: [
                new CritèreRecherche(Cibles.LISTE_MEQ.code, Comparateurs.EST_PARMI.code, Array.from(listeMEQValeurs.values()).map(v => v[0])),
                new CritèreRecherche(Cibles.MEQ_THÈME.code, Comparateurs.ÉGALE.code, v),
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        }
    });
}

function getListeSuggestions() {
    return [...listeMEQValeurs.entries()].map(([c, v]) => {
        return {
            nom: c.charAt(0).toUpperCase() + c.slice(1),
            critères: [
                new CritèreRecherche(Cibles.LISTE_MEQ.code, Comparateurs.ÉGALE.code, v)
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        }
    });
}

function getClassesDeMots() {
    const classesExclues = ["nom commun", "nom propre", "interjection"];
    return [...classeDeMotValeurs.entries()]
        .filter(([classe]) => !classesExclues.includes(classe))
        .map(([c, v]) => {
        return {
            nom: c.charAt(0).toUpperCase() + c.slice(1),
            critères: [
                new CritèreRecherche(Cibles.LISTE_MEQ.code, Comparateurs.EST_PARMI.code, Array.from(listeMEQValeurs.values()).map(v => v[0])),
                new CritèreRecherche(Cibles.CLASSE_DE_MOT.code, Comparateurs.ÉGALE.code, [v.join(",")]),
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        }
    });
}

function getFormationDesMotSuggestions() {
    return [
        {
            nom: "Composition",
            critères: [
                new CritèreRecherche(Cibles.LISTE_MEQ.code, Comparateurs.EST_PARMI.code, Array.from(listeMEQValeurs.values()).map(v => v[0])),
                new CritèreRecherche(Cibles.MEQ_COMPOSITION.code, Comparateurs.EST_PARMI.code, Array.from(meqComposition.values()).map(v => v[0])),
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        },
        {
            nom: "Dérivation à partir d’une lettre muette",
            critères: [
                new CritèreRecherche(Cibles.LISTE_MEQ.code, Comparateurs.EST_PARMI.code, Array.from(listeMEQValeurs.values()).map(v => v[0])),
                new CritèreRecherche(Cibles.MEQ_DÉRIVATION.code, Comparateurs.EST_PARMI.code, Array.from(meqDérivation.values()).map(v => v[0])),
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        },
    ]
}




function getValeursSimplesSuggestions(cible, cibleMap) {
    return [...cibleMap.entries()].map(([c, v]) => {
        return {
            nom: c.charAt(0).toUpperCase() + c.slice(1),
            critères: [
                new CritèreRecherche(Cibles.LISTE_MEQ.code, Comparateurs.EST_PARMI.code, Array.from(listeMEQValeurs.values()).map(v => v[0])),
                new CritèreRecherche(cible.code, Comparateurs.ÉGALE.code, v),
            ],
            options: OptionRecherche.FiltreLemmesSeulementOptions
        }
    })
}



